import {
    Component,
    Prop,
    Vue
} from "vue-property-decorator";
import FadeLoader from 'vue-spinner/src/FadeLoader.vue';
export default {
    props: {
    },
    components: {
        FadeLoader
    },
    data() {
        return {
            color: '#EB7400',
            width: 14,
            hieght: 14,
        }

    },
    // Computed Value
    computed: {

        loading(){
            return this.$store.state.loading
        }
    },
    methods: {
    },
    mounted: function () {
    },
    created: async function () {
    },
}